import styled from "styled-components";

export const Container = styled.main`
  margin: 0 auto;
  max-width: 1400px;
  padding: 0 16px;
`;
